export const session = {
  expired: 'Sua sessão expirou. Entre de novo.',
} as const
